module.exports = __webpack_public_path__ + "img/shequ.91576d34.jpg";